document.addEventListener('DOMContentLoaded', function () {
  // Hamburger menu functionality
  const mobileMenuButton = document.getElementById('mobile-menu-button');
  let mobileMenu = null;
  let closeMobileMenu = null;

  function createMobileMenu() {
    // Only create if not already present
    if (document.getElementById('mobile-menu')) return;
    const menu = document.createElement('div');
    menu.id = 'mobile-menu';
    menu.className = 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-90 z-[9999] flex flex-col items-center justify-center space-y-8 text-center md:hidden menu-open';
    menu.innerHTML = `
      <button id="close-mobile-menu" class="absolute top-6 right-6 text-white text-4xl font-bold focus:outline-none" aria-label="Close Menu">&times;</button>
      <a href="home.html" class="menu-link text-white text-2xl font-heading hover:text-gray-200 transition-colors uppercase tracking-wider mt-12">HOME</a>
      <a href="services.html" class="menu-link text-white text-2xl font-heading hover:text-gray-200 transition-colors uppercase tracking-wider">TRADES</a>
      <a href="certifications.html" class="menu-link text-white text-2xl font-heading hover:text-gray-200 transition-colors uppercase tracking-wider">CERTIFICATIONS</a>
      <a href="projects.html" class="menu-link text-white text-2xl font-heading hover:text-gray-200 transition-colors uppercase tracking-wider">PAST PROJECTS</a>
      <a href="contact.html" class="menu-link text-white text-2xl font-heading hover:text-gray-200 transition-colors uppercase tracking-wider">CONTACT</a>
    `;
    document.body.appendChild(menu);
    return menu;
  }

  function openMenu() {
    mobileMenu = createMobileMenu() || document.getElementById('mobile-menu');
    closeMobileMenu = document.getElementById('close-mobile-menu');
    // Fade in menu
    setTimeout(() => {
      mobileMenu.classList.add('menu-open');
      // Animate links in sequence
      const links = mobileMenu.querySelectorAll('.menu-link');
      links.forEach((link, i) => {
        setTimeout(() => {
          link.classList.add('visible');
        }, 200 + i * 120);
      });
    }, 10);
    closeMobileMenu.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('menu-open');
    // Remove link animations
    mobileMenu.querySelectorAll('.menu-link').forEach(link => link.classList.remove('visible'));
    setTimeout(() => {
      if (mobileMenu) {
        mobileMenu.remove();
        mobileMenu = null;
      }
    }, 400);
  }

  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', openMenu);
  }
});
